import cookies from 'js-cookie';

import { COOKIE_DOMAIN } from '../config';
import cookieNames from '../constants/cookieNames';
import emitterEvents from '../constants/emitterEvents';
import storageKeys from '../constants/storageKeys';
import hashRefreshToken from './hashRefreshToken';
import { setItem } from './storage';

const setTokensOnLocalStorage = (tokens) => {
  const sessionCookie =
    decodeURIComponent(cookies.get(cookieNames.sessionHash)) || false;
  const hasRememberMeInSession = sessionCookie
    ? sessionCookie.split('|')[2] === '1'
    : false;

  const options = {
    domain: COOKIE_DOMAIN,
    ...(tokens.rememberMe ? { expires: 7 } : {}),
  };

  setItem(
    tokens.rememberMe
      ? [window.localStorage, window.sessionStorage]
      : [window.sessionStorage],
    storageKeys.loginTokens,
    JSON.stringify(tokens)
  );

  cookies.set(
    cookieNames.sessionHash,
    hashRefreshToken(
      tokens.refresh.token,
      tokens.rememberMe || hasRememberMeInSession
    ),
    options
  );
  cookies.set(cookieNames.loggedIn, '1', options);

  window.loginStateResolved = true;
  window.emitter.emit(emitterEvents.loginState, true);
};

export default setTokensOnLocalStorage;
